import { render, staticRenderFns } from "./CopyConcertComponent.vue?vue&type=template&id=1d431801&"
import script from "./CopyConcertComponent.vue?vue&type=script&lang=js&"
export * from "./CopyConcertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports